import {push} from "connected-react-router";

const deliveryPointsExport = () => push("/analysis/delivery-points-export");

export const gotoDeliveryPointsExport = {
  deliveryPointsExport: deliveryPointsExport,
};
